import { IOneReportState } from '../slices/oneReportSlice';
import { RootState } from '../store';

export const selectOneReport = (state: RootState): IOneReportState => state.oneReport;
